import { el, on } from '@/lib/dom';

export type ToggleOpts = {
  label: string;
  value: boolean;
  onChange: (v: boolean) => void;
};

export function toggleControl(opts: ToggleOpts): HTMLElement {
  let value = opts.value;
  const dot = el('span', { class: 'tg-dot' });
  const track = el('span', { class: 'tg-track' }, [dot]);
  if (value) track.classList.add('on');

  const root = el('div', { class: 'tg', role: 'switch', tabindex: 0, ariaLabel: opts.label }, [
    el('span', { class: 'sl-label' }, [opts.label]),
    track,
  ]);
  root.setAttribute('aria-checked', String(value));

  function flip(): void {
    value = !value;
    track.classList.toggle('on', value);
    root.setAttribute('aria-checked', String(value));
    opts.onChange(value);
  }

  on(root, 'click', flip);
  on(root, 'keydown', (ev) => {
    if (ev.key === ' ' || ev.key === 'Enter') {
      ev.preventDefault();
      flip();
    }
  });

  return root;
}
